import { ref, computed } from 'vue'
import { defineStore } from 'pinia'
import { useQuery } from '@tanstack/vue-query'
import api from '@/services/axios'
import type { Business, Order, Stats } from '@/types'
export const useCustomerStore = defineStore('customer', () => {
  const recentOrders = ref<Order[]>([])
  const businesses = ref<Business[]>([])
  const stats = ref<Stats>({})

  // Query for fetching recent orders
  const customerDataQuery = useQuery({
    queryKey: ['customerData'],
    queryFn: async () => {
      const response = await api.get('/api/customer/dashboard')
      recentOrders.value = response.data.recentOrders
      businesses.value = response.data.businesses
      stats.value = response.data.stats
      return response.data;
    },
    enabled: false,
  })

  // Query for fetching businesses
  // const businessesQuery = useQuery({
  //   queryKey: ['businesses'],
  //   queryFn: async () => {
  //     const response = await api.get('/api/customer/businesses')
  //     return response.data
  //   },
  //   onSuccess: (data) => {
  //     businesses.value = data
  //   },
  //   refetchOnWindowFocus: false,
  // })

  // Function to manually refresh data
  const refreshData = () => {
    customerDataQuery.refetch()
    // businessesQuery.refetch()
  }

  return {
    recentOrders,
    businesses,
    stats,
    customerDataQuery,
    refreshData,
    isLoading: computed(() => customerDataQuery.isLoading.value),
    isError: computed(() => customerDataQuery.isError.value),
  }
})
